import React, { useEffect, useState } from "react";
import {
  UsersRound,
  Target,
  Flag,
  TrendingUp,
  Flower2,
  HandHeart,
  Trophy,
  Handshake,
} from "lucide-react";
import {
  DEFAULT_STRUCTURED_ABOUT_TITLE,
  DEFAULT_WEBSITE_ABOUT_SECTIONS,
} from "../../data/aboutContent";
import { aboutImageSrc, fetchPublicAbout } from "../../utils/publicSiteContent";
import "../../styles/about.css";

const ICONS = {
  users: UsersRound,
  target: Target,
  flag: Flag,
  "trending-up": TrendingUp,
  flower: Flower2,
  "hand-heart": HandHeart,
  trophy: Trophy,
  handshake: Handshake,
};

function AboutIcon({ icon, imageUrl }) {
  const src = aboutImageSrc(imageUrl);
  const [failedSrc, setFailedSrc] = useState(null);
  const Icon = ICONS[icon] || UsersRound;
  return (
    <span className="smym-about-icon" aria-hidden="true">
      {src && failedSrc !== src ? (
        <img src={src} alt="" loading="lazy" onError={() => setFailedSrc(src)} />
      ) : (
        <Icon strokeWidth={1.6} />
      )}
    </span>
  );
}

function AboutCard({ card, primary = false }) {
  return (
    <article className={`smym-about-card${primary ? " smym-about-card-primary" : ""}`}>
      <AboutIcon icon={card.icon} imageUrl={card.imageUrl} />
      <div>
        <h3>{card.heading}</h3>
        <p>{card.text}</p>
      </div>
    </article>
  );
}

const AboutSection = () => {
  const [about, setAbout] = useState(null);
  useEffect(() => {
    const ctrl = new AbortController();
    fetchPublicAbout({ signal: ctrl.signal })
      .then((content) => {
        if (!ctrl.signal.aborted && content) setAbout(content);
      })
      .catch(() => {});
    return () => ctrl.abort();
  }, []);
  const sections = about?.sections || DEFAULT_WEBSITE_ABOUT_SECTIONS;
  const title =
    about?.sections && about.title ? about.title : DEFAULT_STRUCTURED_ABOUT_TITLE;
  return (
    <section
      id="about"
      aria-labelledby="smym-about-title"
      className="smym-section smym-about-section"
    >
      <div className="smym-about-inner">
        <header className="smym-about-header">
          <h2 id="smym-about-title" className="smym-section-title">
            {title}
          </h2>
          <p className="smym-about-tagline">{sections.tagline}</p>
        </header>
        <div className="smym-about-intro">
          <AboutCard card={sections.whoWeAre} primary />
          <div className="smym-about-intentions">
            <AboutCard card={sections.vision} />
            <AboutCard card={sections.purpose} />
          </div>
        </div>
        <div className="smym-about-principles">
          <h3>{sections.guidingHeading}</h3>
          <ul>
            {sections.principles.map((principle) => (
              <li key={principle.id}>
                <span lang="hi">{principle.hindi}</span>
                <span>{principle.english}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="smym-about-activities">
          <h3>{sections.activitiesHeading}</h3>
          <ul>
            {sections.activities.map((activity) => (
              <li className="smym-about-activity" key={activity.id}>
                <AboutIcon icon={activity.icon} imageUrl={activity.imageUrl} />
                <span>{activity.label}</span>
              </li>
            ))}
          </ul>
        </div>
        <footer className="smym-about-footer">
          <p className="smym-about-closing">{sections.closing}</p>
          <p className="smym-about-affiliation">{sections.affiliation}</p>
        </footer>
      </div>
    </section>
  );
};
export default AboutSection;
